<template lang="pug">
  .wrap
    JobSidebar(
      :openSidebar="openSidebar"
      :fixedViewEndDate="false"
      :focusSalaryNonce="focusSalaryNonce"
      @toggleSidebar="toggleSidebar")

    .main
      .job-list
        .job-list-header(:class="{ 'job-list-header-fixed-sp': this.headerFixedSp }")
          JobSortArea(@toggleSidebar="toggleSidebar" :totalCount="pagination.totalCount")
        Pagination(
          :pagination="pagination"
          :listUpside="true"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage"
          @updatePerPage="updateJobsPerPage")
        .job-list-body
          JobColumnSortModal
          table.row-list
            JobTableHeader(
              :checked="pageAllChecked",
              @check="togglePageCheck"
              @searchOrderBy="searchOrderBy"
              @requireSalaryType="focusSalaryCondition"
            )
            JobTableRow(
              v-for="(v, i) in index",
              :job="v",
              :index="i",
              :key="v.id",
              :checkedIds="pageCheckedIds",
              :updateFavorForIndex="true",
              :updateMarkForIndex="true",
              :exclusionCompanyName="exclusionCompanyName",
              @display="displayDetailModal",
              @check="toggleCheck"
              @hideCompany="hideCompany"
            )
        Pagination(
          :pagination="pagination"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage"
          @updatePerPage="updateJobsPerPage")
      JobShowModal(
        :isOpened="openJobShowModal"
        :jobDetail="jobDetail"
        :updateFavorForIndex="true"
        :haken="this.$route.name === 'SearchHaken'"
        @hide="hideJobShowModal"
        @update="skipReload")
      JobMenu(@remove="reloadOrSkip" :checkedIds="checkedIdsAll" @setJobModalMode="setJobModalMode")

    SearchConditionModal

    Footer
</template>

<script>
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { ErrorMessages, HumanErrorMessages, perPages } from '../../constants'
  import JobColumnSortModal from '../parts/JobColumnSortModal'
  import Footer from '../parts/Footer'
  import JobShowModal from '../parts/JobShowModal'
  import JobSidebar from '../parts/JobSidebar'
  import JobSortArea from '../parts/JobSortArea'
  import JobTableHeader from '../parts/JobTableHeader'
  import JobTableRow from '../parts/JobTableRow'
  import JobMenu from '../parts/JobMenu'
  import SearchConditionModal from '../parts/SearchConditionModal'
  import Pagination from '../parts/Pagination'

  export default {
    components: {
      JobColumnSortModal,
      Footer,
      JobShowModal,
      JobSidebar,
      JobSortArea,
      JobTableHeader,
      JobTableRow,
      JobMenu,
      SearchConditionModal,
      Pagination,
    },
    async asyncData ({ store, route: { query, name } }) {
      if (!Object.keys(query).length) {
        throw new Error(ErrorMessages.NO_PARAMETER_SEARCH_JOB)
      }
      if (!perPages.map(p => p.code).includes(query.perPage)) {
        throw new Error(ErrorMessages.INVALID_PER_PAGE_SEARCH_JOB)
      }

      await store.dispatch('job/fetchIndex', { ...query, haken: (name === 'SearchHaken') })
      await store.dispatch('client/fetch')
    },
    data () {
      return {
        headerFixedSp: false,
        openJobShowModal: false,
        openSidebar: false,
        openSearchConditionModal: false,
        // 給与列ヘッダーから給与条件へ誘導するためのトリガ（更新するたびに JobSidebar が反応する）
        focusSalaryNonce: 0,
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    created () {
      this.uncheckAll()
      this.avoidBlank()
      this.fetchExclusionCompanyName()
    },
    computed: {
      ...mapGetters('job', ['pageAllChecked']),
      ...mapGetters('common', ['spMode']),
      ...mapState({
        meta: state => state.route.meta,
        pagination: state => state.job.pagination,
        index: state => state.job.index,
        pageCheckedIds: state => state.job.pageCheckedIds,
        checkedIdsAll: state => state.job.checkedIds,
        jobDetail: state => state.job.detail,
        exclusionCompanyName: state => state.exclusionCompanyName.enable,
      }),
      page () {
        return this.$route.query.page
      },
      perPage () {
        return this.$route.query.perPage
      },
    },
    watch: {
      $route (to, from) {
        if (to.name !== from.name) {
          this.uncheckAll()
        }
        this.avoidBlank()
      },
    },
    methods: {
      ...mapMutations('job', ['check', 'uncheck', 'uncheckAll']),
      ...mapActions('job', ['toggleCheck', 'togglePageCheck', 'hideCompany']),
      sort ({ orderedColumns, checkedKeys }) {
        this.columns = orderedColumns
        this.displayedColumns = checkedKeys
      },
      displayDetailModal ({ id }) {
        if (id !== this.jobDetail.id) {
          this.$store.dispatch('job/fetchDetail', { id })
            .then(() => {
              this.openJobShowModal = true
            })
        } else {
          this.openJobShowModal = !this.openJobShowModal
        }
      },
      handleScroll () {
        if (this.spMode) {
          this.headerFixedSp = (window.scrollY > 60)
        } else {
          this.headerFixedSp = false
        }
      },
      async searchOrderBy (order, orderDirection) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            order,
            orderDirection,
            page: '1',
            _t: Date.now(),
          },
        })
      },
      hideJobShowModal () {
        this.openJobShowModal = false
      },
      async selectPage (page) {
        this.reload({ page })
      },
      async selectPerPage (perPage) {
        this.updateJobsPerPage(perPage)
        this.reload({ perPage, page: '1' })
      },
      reload ({ perPage, page } = {}) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            perPage: perPage || query.perPage,
            page: page || query.page,
            _t: Date.now(),
          },
        })
      },
      reloadOrSkip () {
        if (this.spMode) {
          return
        }
        this.reload()
      },
      skipReload () {},
      avoidBlank () {
        const { query } = this.$route
        const page = parseInt(query.page, 10) || 1

        // 直近の fetchIndex がエラーで終わった場合、index.length === 0 は
        // 「結果が無い」のではなく「取得失敗」を意味する。page-- すると
        // 同じエラーが続くページを延々と叩き続ける UX になるため早期 return する。
        if (this.$store.state.job.lastFetchError) return

        // 連射防止：直近に発火していれば追加の push はしない。
        // これが無いと API エラー（504 / 422 等）時に `this.index.length === 0`
        // と評価されて、ページ番号を1ずつ減らしながら延々とリクエストを
        // 飛ばし続けてしまい、バックエンドを過負荷にする。
        // eslint-disable-next-line no-underscore-dangle
        if (this._avoidBlankGuard) return

        if (!this.index.length && page > 1) {
          // eslint-disable-next-line no-underscore-dangle
          this._avoidBlankGuard = true
          // eslint-disable-next-line no-underscore-dangle
          setTimeout(() => { this._avoidBlankGuard = false }, 3000)
          this.$router.push({ query: { ...query, page: page - 1 } })
        }
      },
      async fetchExclusionCompanyName () {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('exclusionCompanyName/fetch')
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      async search () {
        this.$store.commit('common/lockGlobal')
        try {
          const query = this.query(new Date().getTime())
          this.$router.push({ name: this.$route.name, query })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
      // 給与ソートには給与種別が要る。文言で案内しつつ、サイドバーの給与条件まで誘導する。
      // PC ではサイドバーが常時表示なので openSidebar は効かず、スクロールだけでは
      // 「押しても何も起きない」ように見える。文言を出すのはそのため。
      //
      // error には **文字列をそのまま渡す**（`new Error(...)` で包まない）。
      // pushToastError の重複抑止は `toast.errors.indexOf(error)` の値比較なので、
      // Error を都度生成すると一致せず、ヘッダーを連打した分だけ同じ行が積み上がる。
      // 同じ理由で CHECKED_LIMIT も文字列で渡している（store/modules/ の5ファイル・計10箇所）。
      focusSalaryCondition () {
        this.$store.dispatch('common/pushToastError', {
          error: HumanErrorMessages.SALARY_SORT_REQUIRES_TYPE,
        })
        this.openSidebar = true
        this.focusSalaryNonce = Date.now()
      },
      async updateJobsPerPage (jobsPerPage) {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('user/updateJobsPerPage', { jobsPerPage })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      setJobModalMode () {
        this.$store.commit('common/setJobModalMode')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/search/SearchJob.vue